import { render, staticRenderFns } from "./deanIcon.vue?vue&type=template&id=a34edfea&scoped=true"
import script from "./deanIcon.vue?vue&type=script&lang=ts"
export * from "./deanIcon.vue?vue&type=script&lang=ts"
import style0 from "./deanIcon.vue?vue&type=style&index=0&id=a34edfea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34edfea",
  null
  
)

export default component.exports